import FormContainer from "components/form";
import Link from "components/ui/Link";
import { Heading } from "components/ui/Text";
import Tile from "components/ui/Tile";
import UILabel from "components/ui/UILabel";
import { useEffect } from "react";
import {
  usePostUsersSignInMutation,
  usePostUsersSignUpMutation,
} from "store/api/apiSlice";
import styled from "styled-components";
import { ApiUsersProduct } from "utils/api/users";
import { getPartnerConfig } from "utils/partner";
import { mediaMax } from "utils/theme";
import Form from "./Form";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 48px;
  gap: 24px;

  background: ${(props) => props.theme.colors.primary};
  background-size: cover;
  background-position: center;
  color: ${(props) => props.theme.reverseColors.primary};

  font-family: ${(props) => props.theme.fonts.body};

  ${mediaMax("md")} {
    padding: 24px;
  }
`;

const Logo = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);

  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;

  img {
    height: 40px;
  }
`;

const FormTile = styled(Tile)`
  width: 100%;
  max-width: 480px;
`;

const Footer = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const LogIn = ({ isSignup }) => {
  const partner = getPartnerConfig();
  const [logIn, { isSuccess: isSuccessLogIn }] = usePostUsersSignInMutation();
  const [signUp, { isSuccess: isSuccessSignUp }] = usePostUsersSignUpMutation();

  const onSubmit = async (user) => {
    await (isSignup ? signUp({ user }) : logIn({ user }));
  };

  useEffect(() => {
    if (isSuccessLogIn || isSuccessSignUp) {
      window.location.pathname = "/dashboard";
    }
  }, [isSuccessLogIn, isSuccessSignUp]);

  return (
    <Wrapper
      style={{ backgroundImage: `url(/partner/${partner.slug}/splash-bg.svg)` }}
    >
      <Logo>
        <img
          src={`/partner/${partner.slug}/logo-reverse.svg`}
          alt={partner.name}
        />
      </Logo>

      <Heading.H3>{isSignup ? "Sign Up" : "Log In"}</Heading.H3>

      <FormTile size="xl">
        <FormContainer
          onSubmit={onSubmit}
          defaultValues={{ product: ApiUsersProduct.ewaFlex }}
        >
          <Form isSignup={isSignup} />
        </FormContainer>

        <Footer>
          <UILabel.Medium>
            {isSignup ? "Have an account?" : "Need an account?"}
          </UILabel.Medium>
          <Link href={isSignup ? "/users/sign_in" : "/users/sign_up"}>
            {isSignup ? "Log in" : "Sign up"}
          </Link>
        </Footer>
      </FormTile>
    </Wrapper>
  );
};

export default LogIn;
